import script from "./ConfluenceMacroSettingsModalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceMacroSettingsModalLayout.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceMacroSettingsModalLayout.vue?vue&type=style&index=0&id=6c218d34&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c218d34"]])

export default __exports__